// src/redux/settingsPages/helpcenter/helpcenterAPI.js
import apiClient from '../../authentication/utils/core/axios';

const HelpcenterAPI = {
  async fetchCategories() {
    const res = await apiClient.get('/help/categories');
    return Array.isArray(res.data) ? res.data : [];
  },

  async searchArticles(query) {
    const res = await apiClient.get('/help/search', { params: { q: query } });
    return res.data ?? [];
  },

  async submitFeedback(payload) {
    const res = await apiClient.post('/help/feedback', payload);
    return res.data ?? { success: true };
  },
};

export default HelpcenterAPI;
